import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-text-with-one-image',
  templateUrl: './text-with-one-image.component.html',
  styleUrls: ['./text-with-one-image.component.css'],
})
export class TextWithOneImageComponent {
  @Input() data!:any;
  
}
